import { useApi } from "../../../lib/api";
import { useMemo } from "react"
import { useParams } from "react-router-dom"

export function usePrograms(ClientUuid: string | undefined) {
  const { id } = useParams()
  const [response, error, loading, retry] = useApi(`/clients/` + ClientUuid + `/players-report/${id}/Programs/Mobile`)

  const data = useMemo(() => response?.data?.array ?? [], [response?.data?.array])

  return useMemo(() => [data, error, loading, retry], [data, error, loading, retry])
}

export function SetActiveProgram(ClientUuid: string | undefined , position: number , dataStatus:boolean) {
  console.log(dataStatus)
  const { id } = useParams()
  const [response, error, loading, retry] = useApi(`/clients/` + ClientUuid + `/players-report/${id}/Programs/${position}/Mobile`,
    { method: 'post',
              blockCall: !dataStatus
    })

  const data = useMemo(() => response?.data ?? [], [response?.data])

  return useMemo(() => [data, error, loading, retry], [data, error, loading, retry])
}

export interface Program {
  created: string
  displayName: string
  id: number
  is24h:boolean
  name:string
  program24hID: number
  updated: string
}
